import React from "react"
import Image from "gatsby-plugin-sanity-image"

// Hooks
import { useMediaQuery } from "@react-hook/media-query"

export const ResponsiveImage = ({ imageLarge, imageSmall, ...rest }) => {
  const matches = useMediaQuery("only screen and (min-width: 400px)")

  const activeImage = matches ? imageLarge : imageSmall
  return (
    activeImage && activeImage.asset && <Image {...activeImage} {...rest} />
  )
}
